export default __webpack_public_path__ + "static/placeholder-style0-16-9-576807b9871336abd0e6821750795a25.png";